export const getTestId = (id: string) => ({ 'data-testid': id })
